import React from 'react';

interface NameByLangProps {
  name_en?: string;
  name_ar?: string;
  name?: string; // Fallback name
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  fallback?: string;
  showFallback?: boolean;
}

const NameByLang: React.FC<NameByLangProps> = ({
  name_en,
  name_ar,
  name,
  className,
  style,
  children,
  fallback = '-',
  showFallback = true,
}) => {
  const currentLang = localStorage.getItem('i18nextLng') || 'en';

  // Get the appropriate name based on current language
  const getDisplayName = () => {
    if (currentLang === 'ar') {
      return name_ar || name_en || name || (showFallback ? fallback : '');
    } else {
      return name_en || name_ar || name || (showFallback ? fallback : '');
    }
  };

  const displayName = getDisplayName();

  // If no display name and we shouldn't show fallback, return null
  if (!displayName && !showFallback) {
    return null;
  }

  // If children are provided, render them with the display name
  if (children) {
    return (
      <span className={`name-by-lang ${className || ''}`} style={style}>
        {React.cloneElement(children as React.ReactElement, {}, displayName)}
      </span>
    );
  }

  // Otherwise, render a simple span
  return (
    <span className={`name-by-lang ${className || ''}`} style={style}>
      {displayName}
    </span>
  );
};

export default NameByLang;
